<template>
  <div class="connectionsList" v-if="connections && connections.length">
    <div class="top">
      <h1 class="title">Connections</h1>
    </div>
    <div class="connections">
      <Connection
        v-for="(connection, index) in connections"
        :key="index"
        :connection="connection"
        :statusType="'connected'"
      />
    </div>
    <div v-if="!isSummary">
      <button
        @click="loadMoreConnections"
        v-if="!allLoaded"
        class="border loadMoreConnections"
      >
        Load more connections
      </button>
      <div v-else class="all-loaded">All Loaded!</div>
    </div>
  </div>
  <div class="connectionsList" v-else>
    <div class="top">
      <h1 class="title">You have no connections :(</h1>
    </div>
  </div>
</template>

<script>
import Connection from "./Connection";

export default {
  name: "ConnectionsList",
  props: ["connections", "allLoaded", "isSummary"],
  components: {
    Connection,
  },
  created() {
    console.log("NICE AT LIST");
  },
  methods: {
    loadMoreConnections() {
      console.log("EYAAA");
      this.$emit("loadMoreConnections");
    },
  },
};
</script>

<style scoped>
.loadMoreConnections {
  font-size: 18px;
  margin-top: 15px;
  margin-left: 5px;
  margin-right: 5px;
  letter-spacing: 0.5px;
  background-color: #ebeff22e;
  padding: 4px 14px;
  font-weight: 700;
  border-radius: 360px;
  cursor: pointer;
  transition: 0.1s ease;
  text-align: center;
  outline: none;
  border-color: unset;
  border: none;
  box-sizing: border-box;
  width: 285px;
  width: 235px;
  margin: auto;
  margin-top: 15px;
  font-family: "Nunito", sans-serif;
  background-color: #2b2c2d;
  color: white;
}
.loadMoreConnections:hover {
  background-color: #49494c;
}
</style>